module.exports = __webpack_public_path__ + "img/user.14128e69.png";